module.exports = __webpack_public_path__ + "img/kumo_3.6a56fce7.svg";